import * as React from 'react';
import { ReviewCookiePolicyRequirementsComponent } from '@src/components/banner-settings/cards/review-cookie-policy-requirements/review-cookie-policy-requirements';
import { AppContext } from '@src/context/store';
import { getAppSettings, getKBLinks } from '@src/context/selectors/ui-settings';
import { isReviewRequirementsInvalid } from '@src/context/selectors/validators';

export const ReviewCookiePolicyRequirements = () => {
  const store = React.useContext(AppContext);
  const { cookiePolicyRequirementApproved } = getAppSettings(store);
  const reviewRequirementInvalid = isReviewRequirementsInvalid(store);
  return (
    <ReviewCookiePolicyRequirementsComponent
      hasError={reviewRequirementInvalid}
      setSaveStatus={store.setSaveStatus}
      updateCookiePolicyRequirement={store.updateCookiePolicyRequirement}
      cookiePolicyRequirementApproved={cookiePolicyRequirementApproved}
      kbLinks={getKBLinks(store)}
    />
  );
};
